import React, { useState, useContext, useEffect, memo } from "react";

import { GlobalContext } from "@/contexts/GlobalContext";

import useFetch from "@/hooks/useFetchData";

import { CartelInfo, VehicleIndex } from "@/types/Vehicles.types";

import styles from "@/styles/components.module.scss";

const VrmSearch = () => {
    const { globalState: { apiUrl }, dispatchGlobal } = useContext(GlobalContext);
    const { useFetchData } = useFetch();

    const [vrm, setVRM] = useState<string | null>(null);

	const [submitVrm, setSubmitVrm] = useState<boolean>(false);
	const [isFetching, setIsFetching] = useState<boolean>(false);

    useEffect(() => {
		if (submitVrm && vrm) {
			fetchVrm(vrm);
			setSubmitVrm(false);
		}
	}, [submitVrm, vrm]);

    const fetchVrm = async (vrm: string) => {
		const url: string = `${apiUrl}/vehicles/vrm?reg=${vrm}`;

		try {
			const result = await useFetchData<{ vehicle: VehicleIndex; vrm?: CartelInfo }>(
                url,
                {
                    method: "GET"
                },
                true
            );

			setIsFetching(false);

            if (!result.success) {
                return false;
            }

            const vh = result.data.vehicle;
            const make = vh.MAKE.toLowerCase().replace(/\s+|,\s/g, "-");
            const model = vh.MODEL1.toLowerCase().replace(/\s+|,\s/g, "-");

            dispatchGlobal({ type: "SET_VHINFO", vhInfo: vh });

            localStorage.setItem("__vhi", JSON.stringify(vh));
            localStorage.setItem("__ktype", vh.KCODE_B);
            localStorage.setItem("_lvsd", new Date().getTime().toString());

            if (result.data.vrm) {
                dispatchGlobal({ type: "SET_VRMINFO", vrmInfo: result.data.vrm });
                localStorage.setItem("_vrmi", JSON.stringify(result.data.vrm));
            } else {
                localStorage.removeItem("_vrmi");
            }

            window.location.href = `/car-parts/${make}/${model.replace(/\//g, "-")}/${vh.KCODE_B}`;
		} catch (error) {
			console.error(error);
		}
	};

    const handleVrmChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { value } = event.currentTarget;

		if (value === "") {
			return setVRM(null);
		}

		if (value.match(/^[0-9a-zA-Z\s]+$/)) {
			return setVRM(value.toUpperCase().replace(/\s+/g, ""));
		}

		return false;
	};

	const handleSubmitVrm = (event: React.FormEvent) => {
		event.preventDefault();

		if (vrm && vrm.length > 0) {
			setIsFetching(true);
			setSubmitVrm(true);
		}
	};

	const vrmForm = (
		<div className={styles["vrm-search"]}>
            <p>Search for vehicle by entering a registration number below</p>
			<form onSubmit={handleSubmitVrm} className={styles["vrm-form"]}>

                <div className={styles["reg-bg"]}>
                    <div className={styles["vrm-flag"]}>
                        <img 
                            src={`${process.env.NEXT_PUBLIC_CDN_URI}/static/images/flags/uj_flag.png`} 
                            alt="uk-flag" 
                            className="vrm-flag"
                        />
                        <span>GB</span>
                    </div>
                    <input 
                        type="text" 
                        onChange={handleVrmChange} 
                        className={styles["vrm-input"]} 
                        value={vrm || ""} 
                        spellCheck={false} 
                        placeholder="YOUR REG" 
                        onFocus={(e) => e.target.placeholder = ""} 
                        onBlur={(e) => e.target.placeholder = "YOUR REG"} 
                    />
                </div>

				{/* <div className="vrm-input__appendix"></div> */}
				<input 
                    disabled={isFetching ? true : false} 
                    type="submit" 
                    value="GO" 
                    className={styles["vrm-submit"]} 
                />
			</form>
		</div>
	);

	return (
		<React.Fragment>
			{vrmForm}
		</React.Fragment>
	);
};

export default memo(VrmSearch);
